import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { OrderHistoryActions } from '../actions/index';
import { ApiService } from '../../../../SGRE-shared/services/api.service';
import { GlobalService } from '../../../../SGRE-shared/services/global.service';
import { OrderHistoryEffectService } from './order-history-effect.service';
import { OrderHistoryDetails } from '../order-history-state';
import { LoggerService, tryNormalizeHttpError } from '@spartacus/core';

@Injectable()
export class OrderHistoryFetchEffects {
  protected logger = inject(LoggerService);

  constructor(
    private actions$: Actions,
    private readonly apiService: ApiService,
    private globalService: GlobalService,
    private orderHistoryEffectService: OrderHistoryEffectService
  ) {}

  FetchOrderHistory$: Observable<
    | ReturnType<typeof OrderHistoryActions.fetchOrderHistorySuccess>
    | ReturnType<typeof OrderHistoryActions.fetchOrderHistoryFail>
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(OrderHistoryActions.fetchOrderHistory),
      switchMap((action) => {
        this.globalService.loadingSubject.next(true);
        // console.log('action.payload', action);
        return this.apiService.getOrderHistoryList(action.payload).pipe(
          map((data: OrderHistoryDetails) => {
            if (data) {
              this.globalService.clearMessagesOnDestroy();
              this.globalService.loadingSubject.next(false);
            }
            return OrderHistoryActions.fetchOrderHistorySuccess({
              orderHistoryData: this.orderHistoryEffectService.formatData(
                data,
                action.flag
              ),
            });
          }),
          catchError((error) => {
            this.globalService.loadingSubject.next(false);
            return of(
              OrderHistoryActions.fetchOrderHistoryFail({
                payload: tryNormalizeHttpError(error, this.logger),
              })
            );
          })
        );
      })
    )
  );
}
